import { createAction } from '@ngrx/store';

export const importMonitorItems = createAction('[MowingMonitor] import monitor items');
export const importNotifications = createAction('[MowingMonitor] import notifications');
